import { render, staticRenderFns } from "./HomologationDetail.vue?vue&type=template&id=0d48375d&"
import script from "./HomologationDetail.vue?vue&type=script&lang=js&"
export * from "./HomologationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports